module.exports = __webpack_public_path__ + "static/media/ar.253f9176.svg";